<div class="system-page">
  <h3 class="subheading">{{ 'model.title' | translate }}</h3>

  @if (loading) {
    <div class="system-page__group">
      <p>{{ 'model.loading' | translate }}</p>
    </div>
  }

  @if (error) {
    <div class="system-page__group">
      <p>{{ 'model.load_failed' | translate }}</p>
    </div>
  }

  @if (status) {
    <div class="system-page__group">
      <div class="module">
        <span class="status-badge" [class.status-badge--up]="status.state === 'LOADED'" [class.status-badge--down]="status.state !== 'LOADED'">
          {{ 'model.state.' + status.state | translate }}
        </span>
        <p>{{ 'model.checked_at' | translate }}: {{ status.checkedAt | date: 'medium' }}</p>
      </div>
    </div>

    @if (status.upgradableFiles > 0) {
      <div class="system-page__group">
        <h3 class="subheading">{{ 'model.upgrade_title' | translate }}</h3>
        <div class="module">
          <p>{{ upgradeBody }}</p>
          <a class="btn btn--basic" href="javascript:void(0)" [class.btn--disabled]="downloading" (click)="onDownloadUpgrade()">
            {{ 'model.upgrade_button' | translate }}
          </a>
          @if (downloadFailed) {
            <p>{{ 'model.upgrade_failed' | translate }}</p>
          }
        </div>
      </div>
    }

    <div class="system-page__group">
      <h3 class="subheading">{{ 'model.errors' | translate }}</h3>
      @if (status.errors.length) {
        <table class="status-table">
          <thead>
            <tr>
              <th>{{ 'model.file' | translate }}</th>
              <th>{{ 'model.path' | translate }}</th>
              <th>{{ 'model.message' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (issue of status.errors; track $index) {
              <tr>
                <td>{{ issue.file }}</td>
                <td>{{ issue.path }}</td>
                <td>{{ issue.message }}</td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <p>{{ 'model.none' | translate }}</p>
      }
    </div>

    <div class="system-page__group">
      <h3 class="subheading">{{ 'model.warnings' | translate }}</h3>
      @if (status.warnings.length) {
        <table class="status-table">
          <thead>
            <tr>
              <th>{{ 'model.file' | translate }}</th>
              <th>{{ 'model.path' | translate }}</th>
              <th>{{ 'model.message' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (issue of status.warnings; track $index) {
              <tr>
                <td>{{ issue.file }}</td>
                <td>{{ issue.path }}</td>
                <td>{{ issue.message }}</td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <p>{{ 'model.none' | translate }}</p>
      }
    </div>
  }
</div>
